import Swiper from 'swiper';

// Create a new employeeRoll object
class LendingTreeCarousel {
  init () {
    const carousel = new Swiper('.swiper.carousel-wrap', {
      direction: 'horizontal',
      centeredSlides: true,
      loop: true,
      speed: 4000,
      spaceBetween: 10,

      autoplay: {
        delay: 800,
        stopOnLastSlide: false,
        pauseOnMouseEnter: true,
        disableOnInteraction: false,
      },

      slidesPerView: 2, // Mobile (XS) slidesPerView
      breakpoints: {
        500: {
          slidesPerView: 3,
        },
        550: {
          slidesPerView: 3.5,
        },
        768: {
          slidesPerView: 4,
        },
        1024: {
          slidesPerView: 5.5,
        },
        1440: {
          slidesPerView: 6,
        },
        1920: {
          slidesPerView: 9,
        },
      },
    });

    carousel.init();
  }
}

// Export class as default
export default LendingTreeCarousel;



// WEBPACK FOOTER //
// ./scripts/components/lending-tree-carousel.js